export default function Header() {
  return (
    <header className="header">
      <div className="header__container">
        <div className="header__name">Luis Reyes</div>
        <div className="header__links">
          <a href="#projects" className="header__link">
            Projects
          </a>
          <a href="#contact" className="header__link">
            Contact
          </a>
        </div>
      </div>
    </header>
  );
}
